import { render, staticRenderFns } from "./InventarioEstrato.vue?vue&type=template&id=0e5d4d95&scoped=true"
import script from "./InventarioEstrato.vue?vue&type=script&lang=js"
export * from "./InventarioEstrato.vue?vue&type=script&lang=js"
import style0 from "../../../css/crud.css?vue&type=style&index=0&id=0e5d4d95&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5d4d95",
  null
  
)

export default component.exports